import { gql } from '@apollo/client';

export const UPDATE_CHANNEL = gql`
  mutation updateOneChannel($where: ChannelWhereUniqueInput!, $data: ChannelUpdateInput!) {
    updateOneChannel(where: $where, data: $data) {
      id
      channelStatus {
        id
      }
      assignees {
        id
      }
    }
  }
`;

export const EXPORT_FORM_TO_PIMS = gql`
  mutation exportFormToPims($formId: String!, $petIds: [String]!) {
    formSubmissionExportToPims(data: { id: $formId, petIds: $petIds }) {
      results {
        success
        petId
        formId
        errorType
        errorMessage
      }
    }
  }
`;

export const UPDATE_CHANNEL_MESSAGE_ATTACHMENT = gql`
  mutation updateOneChannelMessageAttachment(
    $where: ChannelMessageAttachmentWhereUniqueInput!
    $data: ChannelMessageAttachmentUpdateInput!
  ) {
    updateOneChannelMessageAttachment(where: $where, data: $data) {
      id
      filename
      url
      uploadStatus
      entityId
      attachmentType
    }
  }
`;

export const UPDATE_ONE_FORM_SUBMISSION = gql`
  mutation updateOneFormSubmission($where: FormSubmissionWhereUniqueInput!, $data: FormSubmissionUpdateInput!) {
    updateOneFormSubmission(where: $where, data: $data) {
      id
      createdAt
      updatedAt
      submittedAt
      formTemplate {
        id
        title
        content
      }
      clinicPet {
        id
        name
        pimsId
      }
      clinicPetParent {
        id
        firstName
        lastName
        pets {
          id
          name
          species
          pimsId
        }
      }
      completedContent
      draftContent
      appointment {
        id
      }
      serviceReminderNotifications {
        id
      }
    }
  }
`;
